// removed by extract-text-webpack-plugin
module.exports = {"filterItem":"UnitCheckboxFilter_filterItem--1dieM"};


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/UnitCheckboxFilter/UnitCheckboxFilter.scss
// module id = 418
// module chunks = 11 12